<template>
<input type="button" v-bind:value="label" class="iti-form__button iti-form__button--space-right"  v-bind:class="{'iti-form__button--red': isSuggested, 'iti-form__button--disabled': isDisabled}" />
</template>

<script>
export default {
    name: "UXButton",
    props: {
        label: String,
        isSuggested: Boolean,
        isDisabled: Boolean
    },
    computed: {}
};
</script>
